import { FormBuilder, FormControl, FormGroup } from "@angular/forms";

export class CustomFormBuilder extends FormBuilder{

    constructor(){
        super();
    }

    create(ob:any){
        return this.createFormGroup(ob);
    }

    private createFormGroup(ob:any){
        let obFormGroup:any = {};
        for(var key in ob){
            if(typeof(ob[key]) == 'object' && !(ob[key] instanceof Date) && ob[key] && ob[key]!= null){
                obFormGroup[key] = this.createFormGroup(ob[key]);
            }
            else{
                obFormGroup[key] = ob[key];
            }
        }
        return this.group(obFormGroup);
    }

    update(formGroup:FormGroup, ob:any){
        this.updateFormGroup(formGroup, ob);
    }

    private updateFormGroup(formGroup:FormGroup, ob:any){
        for(var key in ob){
            if(typeof(ob[key]) == 'object' && !(ob[key] instanceof Date) && ob[key] && ob[key]!= null && formGroup.get(key)){
                this.updateFormGroup((formGroup.get(key) as FormGroup), ob[key])
            }
            else if(formGroup.get(key) && ob[key]!= undefined){
                formGroup.get(key).setValue(ob[key]);
            }
        }
    }

    public build(className:Function, parent = false):FormGroup {        
        const DESIGN_PARAM_TYPES = 'design:paramtypes';
        const metadata = Reflect.getMetadata(DESIGN_PARAM_TYPES, className);

        if(metadata) {
            return this._buildByMetadata(className, metadata);
        }
        
        let obj: any = Object.create(className.prototype);
        let formGroup = new FormGroup({});
        const keys: string[] = this.describe(obj.constructor, parent);
        for (const key in keys) {
            formGroup.addControl(keys[key], new FormControl());
        }
        return formGroup;
    }

    private describe(val: Function, parent = false): string[] {
        const fRegEx = new RegExp(/(?:this\.)(.+?(?= ))/g);
        let result = [];

        if (parent) {
            const proto = Object.getPrototypeOf(val.prototype);
            if (proto) {
                result = result.concat(this.describe(proto.constructor, parent));
            }
        }
        result = result.concat(val.toString().match(fRegEx) || []);
        
        for (const key in result) {
            if (result[key]) {
                result[key] = result[key].replace('this.', '').replace('=void', '');
            }
        }

        return result;
    }

    private _buildByMetadata(classReference: Function, metadata: Array<Function>) {
        const formGroup = new FormGroup({});
        const isClass = (i) => i && /^\s*class/.test(i.toString());

        let obj: any = Object.create(classReference.prototype);
        const keys: string[] = this.describe(obj.constructor);
        
        for (const index in keys) {
            if(isClass(metadata[index])) 
                formGroup.addControl(keys[index], this.build(metadata[index]));
            else
                formGroup.addControl(keys[index], new FormControl());
        }
        
        return formGroup;
    }

    private _filterNulls(obj) {
        let newObj = {};
        Object.keys(obj).forEach((key) => {
          if (obj[key] === Object(obj[key])) newObj[key] = this._filterNulls(obj[key]);
          else if (obj[key]) newObj[key] = obj[key];
        });
        return newObj;
    }
}